import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { hideRecipeRatingPopup } from "@app/store/app/appActions"
import { RootState } from "@app/types"
import { trackRecipeRating, useAutomaticTrackingData } from "@ng-mw/shared-react-components"
// Components
import Popup, { PopupButtons, PopupContent } from "@modules/popup/Popup"
import LazyRender from "@ng-mw/reol/components/LazyRender"
import Button from "@ng-mw/reol/components/Button"
import RecipeRatingButtons from "@ng-mw/shared-react-components/src/modules/recipes/RecipeRatingButtons"
import { sendRecipeRating } from "@ng-mw/shared-react-components/src/modules/recipes/store/actions/recipesRatingActions"

const RecipeRatingPopup = () => {
    const dispatch = useDispatch<any>()
    const [rating, setRating] = useState<number>()
    const [isRatingSubmitted, setIsRatingSubmitted] = useState(false)
    const { visible, recipeItem } = useSelector((state: RootState) => state.app.recipeRatingPopup)
    const automaticTrackingData = useAutomaticTrackingData()

    const handleClose = () => {
        setIsRatingSubmitted(false)
        dispatch(hideRecipeRatingPopup())
    }

    const handleRatingClick = (rating: number) => {
        setRating(rating)
    }

    const handleSendRating = () => {
        /* e.g.
        window.dataLayer.push({
            ...automaticTrackingData
            action : 'Ranger oppskrift',
            antall_stjerner: 5
        });
        */
        trackRecipeRating(
            automaticTrackingData,
            recipeItem?.rawData.name,
            recipeItem?.rawData.id,
            rating,
        )
        dispatch(sendRecipeRating(rating, recipeItem?.rawData.id ?? ""))
        setIsRatingSubmitted(true)

        setTimeout(() => {
            handleClose()
        }, 2000)
    }

    return (
        <Popup
            isOpen={visible}
            onClose={handleClose}
            title={
                isRatingSubmitted
                    ? "Takk for din vurdering!"
                    : "Hvor mange stjerner vil du gi denne oppskriften?"
            }
        >
            <PopupContent>
                <LazyRender
                    isVisible={visible}
                    hiddenClassName=""
                >
                    {recipeItem?.rawData?.id ? (
                        <RecipeRatingButtons
                            recipeId={recipeItem.rawData.id}
                            isNative
                            onRatingClick={handleRatingClick}
                        />
                    ) : (
                        <p>Det er skjedd en feil</p>
                    )}
                </LazyRender>
            </PopupContent>
            <PopupButtons isSimple>
                <Button
                    onClick={handleSendRating}
                    text="Bekreft"
                    isDisabled={isRatingSubmitted}
                />
                <Button
                    onClick={handleClose}
                    text="Avbryt"
                    isSecondary
                />
            </PopupButtons>
        </Popup>
    )
}

export default RecipeRatingPopup
